//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import teamTheme from './TeamRenderer.scss';
import classnames from 'classnames';
import { listCardFactory } from 'common/components/core/card/ListCard';
import TeamChip from 'common/components/core/common/TeamChip';
import { dashboardColors } from 'common/enums/ColorEnum';
import { TeamStatusEnum } from 'common/enums/TeamEnum';

export const IconWithBg = ({ iconColor, className, theme }) => {
    const backgroundStyle = { backgroundColor: iconColor };
    return (
        <div
            className={classnames(theme.iconWithBg, className)}
            style={backgroundStyle}
        />
    );
};

export const LeftIconWithBg = ({ leftIconBgColor, theme }) => {
    return (
        <IconWithBg
            className={classnames(theme.leftIcon, theme.borderIcon)}
            iconColor={leftIconBgColor}
            theme={theme}
        />
    );
};

const ListCardWithColor = listCardFactory({
    LeftIcon: LeftIconWithBg
});

const TeamOptionRenderer = props => {
    const {
        data,
        innerProps,
        innerRef,
        theme,
        isSelected,
        isFocused,
        disabled
    } = props;
    return (
        <ListCardWithColor
            innerRef={innerRef}
            noPadding
            zIndexAuto
            theme={theme}
            className={classnames(theme.teamCard, theme.optionRender)}
            title={data.label}
            leftIconBgColor={data.color}
            isSelected={isSelected}
            isCardFocused={isFocused}
            testId={innerProps.id.replace(/react-select-[0-9]+-/g, '')}
            disabled={disabled}
            {...innerProps}
        />
    );
};

const TeamValueRenderer = props => {
    const { data, theme } = props;

    return (
        <ListCardWithColor
            noPadding
            zIndexAuto
            theme={theme}
            className={classnames(theme.teamCard, theme.valueRender)}
            title={data.label}
            leftIconBgColor={data.color}
        />
    );
};

const TeamPlaceholderRenderer = props => {
    const { children, theme } = props;
    return (
        <ListCardWithColor
            noPadding
            zIndexAuto
            theme={theme}
            className={classnames(theme.teamCard, theme.placeholderRender)}
            title={children}
        />
    );
};

class MultiTeamValue extends React.PureComponent {
    render() {
        const { theme, removeProps, data } = this.props;
        let backgroundColor = `${dashboardColors.black.name}01`;
        if (!data.status || data.status === TeamStatusEnum.Inactive) {
            backgroundColor = `${dashboardColors.salmonTwo.name}`;
        }
        const disabled = this.props.disabled || this.props.isDisabled;
        return (
            <TeamChip
                className={theme.multiValueContainer}
                theme={theme}
                teamName={data.label}
                teamColor={data.color}
                invert={false}
                rightIcon="cancel-thin"
                backgroundColor={backgroundColor}
                disabled={disabled}
                rightIconProps={removeProps}
            />
        );
    }
}

const ThemedTeamOptionRenderer = themr(
    'TeamOptionRenderer',
    teamTheme
)(TeamOptionRenderer);

const ThemedTeamValueRenderer = themr(
    'TeamValueRenderer',
    teamTheme
)(TeamValueRenderer);

const ThemedTeamPlaceholderRenderer = themr(
    'TeamPlaceholderRenderer',
    teamTheme
)(TeamPlaceholderRenderer);

const ThemedMultiTeamValue = themr(
    'TeamPlaceholderRenderer',
    teamTheme
)(MultiTeamValue);

export {
    ThemedTeamOptionRenderer as TeamOptionRenderer,
    ThemedTeamValueRenderer as TeamValueRenderer,
    ThemedTeamPlaceholderRenderer as TeamPlaceholderRenderer,
    ThemedMultiTeamValue as MultiTeamValue
};
